export default __webpack_public_path__ + "static/media/home_thumb_WOZ_.c6e1a988.png";